import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@knockrentals/knock-shared-web-v2';
import { makeCss } from '../../../../../../../../knock-design-system';

const useCss = makeCss({
  brandingTile: {
    '& .MuiCard-root': {
      height: '122px',
      marginTop: '8px',
      width: '122px',
    },
  },
});

const BrandingTile = ({ className, children, title }) => {
  const css = useCss();
  return (
    <div className={className} css={css.brandingTile}>
      <Typography color="text.tertiary" variant="overline2">
        {title}
      </Typography>
      {children}
    </div>
  );
};

BrandingTile.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string,
};

export default BrandingTile;
